import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';

export const usernameValidationInterceptor: HttpInterceptorFn = (req, next) => {
  const router = inject(Router);

  if (environment.ENV_ACTIVE_PROFILE !== environment.ON_CUSTOMIDP) {
    return next(req);
  }

  const username = req.headers.get('username');

  if (req.headers.has('username') && (!username || username === 'null')) {
    localStorage.clear();
    sessionStorage.clear();
    router.navigate(['/unauthorize']);
    throw new Error('Username header is required but was null');
  }

  return next(req);
};
